import React from 'react';
import { IconTag } from '@tabler/icons';
import SimpleLookupCrud from '../references/SimpleLookupCrud';

const Brands = () => (
    <SimpleLookupCrud
        icon={IconTag}
        gradient="amber"
        title="Marcas"
        subtitle="Marcas usadas nos produtos do catálogo"
        endpoint="brands"
        addLabel="Nova marca"
        columns={[{ key: 'name', label: 'Nome', type: 'text', required: true }]}
    />
);

export default Brands;
